import React from 'react';
import PropertyLowScore from './score-image/PropertyLowScore';
import PropertyMediumScore from './score-image/PropertyMediumScore';
import PropertyHighScore from './score-image/PropertyHighScore';
import PropertyVeryLowScore from './score-image/PropertyVeryLowScore';
import PropertyVeryHighScore from './score-image/PropertyVeryHighScore';
export const PropertyScore = ({ score }) => {
    if (score < 20)
        return React.createElement(PropertyVeryLowScore, null);
    if (score < 40)
        return React.createElement(PropertyLowScore, null);
    if (score < 60)
        return React.createElement(PropertyMediumScore, null);
    if (score < 80)
        return React.createElement(PropertyHighScore, null);
    return React.createElement(PropertyVeryHighScore, null);
};
//# sourceMappingURL=PropertyScore.js.map